var _rect, _line, _line2, _line3, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 7,
    fill: "#56AF2D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0,
    x2: 26.16675,
    y2: 0,
    transform: "matrix(0.999253 -0.038637 0.0318245 0.999493 6.9512 14.80325)",
    stroke: "#56AF2D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 0,
    x2: 26.16675,
    y2: 0,
    transform: "matrix(0.999253 -0.038637 0.0318245 0.999493 7.8743 20.56435)",
    stroke: "#56AF2D"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 0,
    x2: 26.16675,
    y2: 0,
    transform: "matrix(0.999253 -0.038637 0.0318245 0.999493 8.7974 26.32545)",
    stroke: "#56AF2D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.56215,
    cy: 17.55105,
    rx: 13.72705,
    ry: 12.40015,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.04315 26.4558L25.31265 24.0905L32.36145 20.0405L34.04315 26.4558Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewicon);
export default __webpack_public_path__ + "static/media/reviewicon.e01f74c026a1777bb0b1fe320d816a48.svg";
export { ForwardRef as ReactComponent };